import React from 'react';
import { motion } from 'framer-motion';
import { Hammer, Wrench, Filter, Cpu, ArrowRight } from 'lucide-react';
const services = [{
  icon: Hammer,
  title: 'Remodelación Completa',
  description: 'Transformamos su piscina antigua en un oasis moderno. Actualización de azulejos, superficies, iluminación y diseño estructural.'
}, {
  icon: Wrench,
  title: 'Diagnóstico y Reparación',
  description: 'Detección de fugas, reparación de bombas, motores y tuberías. Soluciones rápidas y duraderas para cualquier problema.'
}, {
  icon: Filter,
  title: 'Sistemas de Filtración',
  description: 'Instalación y mantenimiento de filtros de alta eficiencia para garantizar un agua cristalina y segura para su familia.'
}, {
  icon: Cpu,
  title: 'Automatización',
  description: 'Controle la temperatura, luces y bombas de su piscina desde su smartphone con sistemas inteligentes de última generación.'
}];
export function Services() {
  return <section id="servicios" className="py-20 bg-gray-50" data-id="element-225">
      <div className="container mx-auto px-4 md:px-6" data-id="element-226">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-227">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-pool-600 font-semibold tracking-wider uppercase text-sm mb-2" data-id="element-228">
            Nuestros Servicios
          </motion.h2>
          <motion.h3 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="text-3xl md:text-4xl font-bold text-navy-900 mb-6" data-id="element-229">
            Soluciones Integrales para su Piscina
          </motion.h3>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.2
        }} className="text-gray-600 text-lg" data-id="element-230">
            Desde renovaciones estéticas hasta actualizaciones tecnológicas,
            ofrecemos todo lo necesario para que disfrute de su piscina sin
            preocupaciones.
          </motion.p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-231">
          {services.map((service, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1,
          duration: 0.5
        }} whileHover={{
          y: -10
        }} className="bg-white rounded-2xl p-8 shadow-lg border border-gray-100 flex flex-col h-full" data-id="element-232">
              <div className="bg-pool-50 w-16 h-16 rounded-xl flex items-center justify-center mb-6 text-pool-600" data-id="element-233">
                <service.icon size={32} strokeWidth={1.5} data-id="element-234" />
              </div>
              <h4 className="text-xl font-bold text-navy-900 mb-4" data-id="element-235">
                {service.title}
              </h4>
              <p className="text-gray-600 mb-8 flex-grow" data-id="element-236">
                {service.description}
              </p>
              <a href="#contacto" className="inline-flex items-center gap-2 text-pool-600 font-semibold hover:text-pool-700 transition-colors group mt-auto" data-id="element-237">
                Más Información
                <ArrowRight size={18} className="group-hover:translate-x-1 transition-transform" data-id="element-238" />
              </a>
            </motion.div>)}
        </div>
      </div>
    </section>;
}